import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import BetaSearchBar from './BetaSearchBar';

const AdvisorClientSearchBarPicker = ({ isMobile, ...rest }) => {
  const { userResource } = useUserContext();

  if (!userResource) {
    return null;
  }

  return pickFunction(userResource, {
    [fr.relationships.searchResults.name]: () => {
      return (
        <BetaSearchBar {...rest} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AdvisorClientSearchBarPicker;
